import { Card } from '@mui/material'
import React from 'react'
import Button from '../Button'
import cssClasses from './DashboardCard.module.css'
import routeImg from '../../Assets/Images/Dashboard/routeImg.png'
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'

export default function DashboardCard({ icon, title, number, selectedProject, showViewDetails, viewDetailsClicked }) {
    const navigate = useNavigate()

    function routeToLeadsTab() {
        if (title === 'Total Leads') {
            // navigate(`/home/Leads?Tab=All&&Project=${selectedProject}&&Status=`)
            navigate(`/home/Leads?Tab=All&&Status=`)
        } else if (title === 'Active Leads') {
            navigate(`/home/Leads?Tab=Nuturing&&Status=`)
        } else if (title === 'Site Visits') {
            navigate(`/home/Leads?Tab=Site Visit&&Status=`)
        } else if (title === 'Total Tokens') {
            navigate(`/home/Leads?Tab=Token&&Status=`)
        } else if (title === 'Booking In Progress') {
            navigate(`/home/Leads?Tab=Allotment&&kycFormFilled=No`)
        } else if (title === 'Booking Done') {
            navigate(`/home/Leads?Tab=Allotment&&kycFormFilled=Yes`)
        }
    }

    return (
        <Card style={{ padding: showViewDetails ? '2rem 2rem 0 2rem' : '2rem 2rem 2rem 2rem' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                {icon && <img className={cssClasses.icon} src={icon} alt="" />}
                {selectedProject &&
                    <img onClick={routeToLeadsTab} style={{ width: '3rem', height: '2rem' }} src={routeImg} alt="" />
                }
            </div>
            <p style={{ fontSize: title === 'Booking In Progress' ? '1.2rem' : '1.6rem', whiteSpace: 'nowrap' }} className={cssClasses.title}>{title}</p>
            <p className={cssClasses.number}>{number}</p>
            <div className={cssClasses.button}>
                {showViewDetails &&
                    <p onClick={() => viewDetailsClicked(title)}>
                        View Details
                    </p>
                }
            </div>
        </Card>
    )
}
